import {
    HighlightsSection,
    HomeFooter,
    HomeHeader,
    HomeHero,
    MomentsSection,
    StoriesSection,
} from '@/features/admin-home';
import { type SharedData } from '@/types';
import { Head, usePage } from '@inertiajs/react';

// import { login, register } from '@/routes';

export default function Home() {
    const { auth } = usePage<SharedData>().props;

    return (
        <>
            <Head title="Discover Staydeed" />
            <div className="min-h-screen bg-gradient-to-b from-slate-50 via-white to-slate-100 text-slate-900 dark:from-gray-950 dark:via-gray-900 dark:to-gray-950">
                <HomeHeader auth={auth} />

                <main className="mx-auto flex w-full max-w-6xl flex-col gap-20 px-6 pt-10 pb-20">
                    <HomeHero />

                    <HighlightsSection />

                    <MomentsSection />

                    <StoriesSection />
                </main>

                <HomeFooter />
            </div>
        </>
    );
}
